export default {
	title: "Fizetési Módszerek",
	tips: "Kedves felhasználó, kérjük, töltse ki ERC20/TRC20 címét. Kérjük, ne adja meg banki számlaadatokat és jelszavát",
	form: {
		TransactionPassword: "Tranzakciós Jelszó",
		Address: "Pénztárcacím"
	},
	label: ["Bank Neve", "Központi Kód", "Központ Neve", "Befizetés Típusa", "Számlaszám", "Számlatulajdonos"],
	tabs: ["Bankkártya", "Hálózat"],
	delete: "Törlés",
	default: "Alapértelmezett",
	create: "Létrehozás",
	type: "Kifizetés Típusa",
	verifying: "ellenőrzés folyamatban",
	VerifyWalletAddress: "Pénztárca-cím ellenőrzése",
	defaultAccount: "Alapértelmezett Kifizetési Számla",
	deleteMsg: "Biztosan törölni szeretné?"
};
